/**
 * Convert hex color to RGB array
 */
export function hexToRgb(hex: string): [number, number, number] {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
    : [0, 0, 0];
}

/**
 * Generate color shades from a base color
 */
export function generateColorShades(baseColor: string) {
  const [r, g, b] = hexToRgb(baseColor);
  
  const shades = {
    50: lighten(r, g, b, 0.95),
    100: lighten(r, g, b, 0.9),
    200: lighten(r, g, b, 0.75),
    300: lighten(r, g, b, 0.6),
    400: lighten(r, g, b, 0.3),
    500: formatRgb(r, g, b),
    600: darken(r, g, b, 0.1),
    700: darken(r, g, b, 0.2),
    800: darken(r, g, b, 0.3),
    900: darken(r, g, b, 0.4),
    950: darken(r, g, b, 0.5),
  };
  
  return shades;
}

function formatRgb(r: number, g: number, b: number): string {
  return `${r} ${g} ${b}`;
}

function lighten(r: number, g: number, b: number, amount: number): string {
  const newR = Math.round(r + (255 - r) * amount);
  const newG = Math.round(g + (255 - g) * amount);
  const newB = Math.round(b + (255 - b) * amount);
  return formatRgb(newR, newG, newB);
}

function darken(r: number, g: number, b: number, amount: number): string {
  const newR = Math.round(r * (1 - amount));
  const newG = Math.round(g * (1 - amount));
  const newB = Math.round(b * (1 - amount));
  return formatRgb(newR, newG, newB);
}
